import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ButtonArrowed from '../Buttons/ButtonArrowed';

import './link-back.scss';

class LinkBack extends PureComponent {
  render() {
    return (
      <div className="link-back">
        <ButtonArrowed
          direction="left"
          {...this.props}
        >
          {this.props.children}
        </ButtonArrowed>
      </div>
    );
  }
}

LinkBack.propTypes = {
  link: PropTypes.string,
  onClick: PropTypes.func
};

export default LinkBack;



// WEBPACK FOOTER //
// ./src/components/widgets/LinkBack/index.js